import * as React from "react";
import { Fragment } from "react";
import ReactDOM from "react-dom";
import styles from "./parameter_hint_modal.module.sass";

const Backdrop: React.FC<{ onClose: () => void }> = (props) => {
  return <div className={styles.hintBackdrop} onClick={props.onClose} />;
};

const ModalOverlay: React.FC<{
  onClose: () => void;
  description: string;
}> = (props) => {
  return (
    <div className={styles.hintContent}>
      <div>
        <button className={styles.hintClose} onClick={props.onClose}>
          ×
        </button>
      </div>
      <div className={styles.text}>
        <div dangerouslySetInnerHTML={{ __html: props.description }} />
      </div>
    </div>
  );
};

const portalElement = document.getElementsByTagName("body")[0];

const ParameterHintModal: React.FC<{
  onClose: () => void;
  description: any;
}> = (props) => {
  return (
    <Fragment>
      {ReactDOM.createPortal(
        <Backdrop onClose={props.onClose} />,
        portalElement
      )}
      {ReactDOM.createPortal(
        <ModalOverlay
          onClose={props.onClose}
          description={props.description}
        />,
        portalElement
      )}
    </Fragment>
  );
};

export default ParameterHintModal;
